export const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
export const MESSAGE_SEVERITY_SUCCESS = 'success';
export const MESSAGE_SEVERITY_ERROR = 'error';
export const MESSAGE_SEVERITY_INFO = 'info';
export const MESSAGE_SEVERITY_WARNING = 'warning';
export const SUPER_ADMIN_OWNER_ID = '*';

export const ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN';
